import React from "react";

const ViewVideo = ({ status }: { status: any }) => {
  return <div>ViewVideo</div>;
};

export default ViewVideo;
